/** i18n FR / HT - tout en français/kreyòl, aucun anglais */
export const dict = {
  fr: {
    appName: "TOP LOTTO",
    login: "Connexion",
    email: "Email",
    password: "Mot de passe",
    signIn: "Se connecter",
    signOut: "Déconnexion",
    dashboard: "Tableau de bord",
    sales: "Vente",
    tickets: "Tickets",
    results: "Résultats",
    payments: "Paiements",
    reports: "Rapports",
    users: "Utilisateurs",
    agencies: "Agences",
    settings: "Paramètres",
    audit: "Audit",
    verify: "Vérifier",
    salesToday: "Ventes du jour",
    paymentsToday: "Paiements du jour",
    profitToday: "Profit du jour",
    ticketsSold: "Tickets vendus",
    winningTickets: "Tickets gagnants",
    balance: "Balance",
    recentTickets: "Derniers tickets",
    recentResults: "Résultats récents",
    salesTrend: "Tendance 7 jours",
    byLottery: "Par loterie",
    lottery: "Loterie",
    drawDate: "Date de tirage",
    currency: "Devise",
    game: "Jeu",
    number: "Numéro",
    numbers: "Numéros",
    amount: "Mise",
    total: "Total",
    add: "Ajouter",
    addToCart: "Ajouter",
    cart: "Panier",
    empty: "Vide",
    clearCart: "Vider",
    saveTicket: "Vendre & imprimer",
    printTicket: "Imprimer",
    searchTicket: "Rechercher ticket par numéro",
    payTicket: "Payer le ticket",
    cancel: "Annuler",
    save: "Enregistrer",
    create: "Créer",
    name: "Nom",
    role: "Rôle",
    agency: "Agence",
    phone: "Téléphone",
    active: "Actif",
    addUser: "Nouveau utilisateur",
    addAgency: "Nouvelle agence",
    enterResults: "Saisir les résultats",
    payoutRates: "Taux de paiement",
    exchangeRate: "Taux BRL → HTG",
    businessInfo: "Informations agence",
    download: "Télécharger CSV",
    welcomeBack: "Bienvenue",
    machann: "Machann",
    superAdmin: "Super Admin",
    profit: "Profit",
    paid: "Payé",
    notPaid: "Non payé",
    winning: "Gagnant",
    pending: "En attente",
    ticketNo: "N° Ticket",
    customer: "Client",
    optional: "facultatif",
    selectLottery: "Sélectionner loterie",
    noTickets: "Aucun ticket",
    noResults: "Aucun résultat",
    actions: "Actions",
    status: "Statut",
    date: "Date",
    payout: "Gain",
    reportSales: "Rapport ventes",
    groupBy: "Grouper par",
    day: "Jour",
    dateFrom: "Du",
    dateTo: "Au",
    apply: "Appliquer",
    delete: "Supprimer",
    edit: "Modifier",
    confirm: "Confirmer",
    payoutSuccess: "Paiement effectué",
    error: "Erreur",
    success: "Succès",
    lang: "Langue",
    quickSearch: "Recherche rapide",
    poweredBy: "Opérations Loterie",
    business: "Agence",
    saveSettings: "Enregistrer paramètres",
    chooseRole: "Choisir rôle",
    welcomeBackTo: "Connectez-vous à votre compte",
    invalidCreds: "Identifiants invalides",
    quickSale: "Vente rapide",
    autoDetected: "Jeu détecté",
    typeNumber: "Tapez 2 à 5 chiffres",
    mariage: "Mariage Boul",
    mariageHelp: "2 numéros — gagnant si les 2 sortent",
    pairsAuto: "Paires automatiques",
    pairsAutoHelp: "Plusieurs numéros, un seul prix",
    pairsAutoEnter: "Entrez plusieurs numéros séparés par espace ou virgule",
    commonAmount: "Mise commune",
    bulkAdd: "Tout ajouter",
    bolet: "Bòlèt",
    bolet2: "Bòlèt (2 chiffres)",
    pick3Label: "Pick 3",
    pick4Label: "Pick 4",
    pick5Label: "Pick 5",
    premye: "Premye (1er)",
    dezyem: "Dezyèm (2e)",
    twazyem: "Twazyèm (3e)",
    mariageRate: "Mariage",
    sessionMidday: "Midi",
    sessionEvening: "Soir",
    eightDraws: "8 tirages",
    pickThree: "Pick 3",
    pickFour: "Pick 4",
    pickFive: "Pick 5",
    saveAllResults: "Enregistrer tous les résultats",
    boul1: "Boul 1",
    boul2: "Boul 2",
    boul3: "Boul 3",
    matched: "Sorti",
    notMatched: "Pas sorti",
    perItemEdit: "Modifier chaque mise",
    convertedFrom: "Converti depuis",
    address: "Adresse",
    ticketFooter: "Message ticket",
    menu: "Menu",
    notifications: "Notifications",
    noNotifications: "Aucune notification",
    markAllRead: "Tout marquer lu",
    online: "En ligne",
    offline: "Hors ligne",
    syncedTickets: "ticket(s) synchronisé(s)",
    failedSync: "échec de synchronisation",
    nothingToSync: "Rien à synchroniser",
    pendingSync: "en attente",
    autoDoubles: "Doubles automatiques (00→99)",
    bulkPaste: "Plusieurs numéros",
    printer: "Imprimante",
    printerConfig: "Configuration imprimante",
    printerType: "Type d'imprimante",
    printerBluetooth: "Bluetooth",
    printerSerial: "USB (Web Serial)",
    printerNetwork: "Réseau (TCP)",
    printerBrowser: "Navigateur",
    printerWidth: "Largeur papier",
    printerIp: "Adresse IP",
    printerPort: "Port",
    testPrint: "Tester impression",
    printing: "Impression...",
    deleteUser: "Supprimer utilisateur",
    deactivateUser: "Désactiver",
    confirmDelete: "Confirmer la suppression ?",
    editTicket: "Modifier ticket",
    cancelTicket: "Annuler ticket",
    deleteTicket: "Supprimer ticket",
    cancelled: "Annulé",
    superAdminActions: "Actions Super Admin",
    commission: "Commission %",
    commissionAmount: "Commission gagnée",
    nextDraw: "Prochain tirage",
    salesClosed: "Vente fermée",
    salesOpenIn: "Ouvre dans",
    drawTime: "Heure tirage",
    timezone: "Fuseau",
    closeOffset: "Fermer X min avant",
    importApi: "Importer résultats API",
    importing: "Importation...",
    apiToken: "Token API",
    apiUrl: "URL API",
    downloadPdf: "Télécharger PDF",
    shareWhatsApp: "Partager WhatsApp",
    lotteries: "Loteries",
    edit: "Modifier",
  },
  ht: {
    appName: "TOP LOTTO",
    login: "Antre",
    email: "Imèl",
    password: "Modpas",
    signIn: "Konekte",
    signOut: "Dekonekte",
    dashboard: "Tablo Kontwòl",
    sales: "Vant",
    tickets: "Tikè",
    results: "Rezilta",
    payments: "Peyman",
    reports: "Rapò",
    users: "Itilizatè",
    agencies: "Ajans",
    settings: "Paramèt",
    audit: "Odit",
    verify: "Verifye",
    salesToday: "Vant Jodi a",
    paymentsToday: "Peyman Jodi a",
    profitToday: "Pwofi Jodi a",
    ticketsSold: "Tikè Vann",
    winningTickets: "Tikè Genyen",
    balance: "Balans",
    recentTickets: "Dènye Tikè",
    recentResults: "Dènye Rezilta",
    salesTrend: "Tandans 7 jou",
    byLottery: "Pa Lotri",
    lottery: "Lotri",
    drawDate: "Dat Tiraj",
    currency: "Lajan",
    game: "Jwèt",
    number: "Nimewo",
    numbers: "Nimewo yo",
    amount: "Lajan w mete",
    total: "Total",
    add: "Ajoute",
    addToCart: "Ajoute",
    cart: "Panye",
    empty: "Vid",
    clearCart: "Vide",
    saveTicket: "Vann & enprime",
    printTicket: "Enprime",
    searchTicket: "Chèche tikè ak nimewo",
    payTicket: "Peye Tikè a",
    cancel: "Anile",
    save: "Sove",
    create: "Kreye",
    name: "Non",
    role: "Wòl",
    agency: "Ajans",
    phone: "Telefòn",
    active: "Aktif",
    addUser: "Nouvo itilizatè",
    addAgency: "Nouvo ajans",
    enterResults: "Antre rezilta yo",
    payoutRates: "To peyman",
    exchangeRate: "To BRL → HTG",
    businessInfo: "Enfòmasyon ajans",
    download: "Telechaje CSV",
    welcomeBack: "Byenvini",
    machann: "Machann",
    superAdmin: "Sipèadmin",
    profit: "Pwofi",
    paid: "Peye",
    notPaid: "Pa peye",
    winning: "Genyen",
    pending: "Ap tann",
    ticketNo: "Nimewo Tikè",
    customer: "Kliyan",
    optional: "opsyonèl",
    selectLottery: "Chwazi lotri",
    noTickets: "Pa gen tikè",
    noResults: "Pa gen rezilta",
    actions: "Aksyon",
    status: "Estati",
    date: "Dat",
    payout: "Gen",
    reportSales: "Rapò vant",
    groupBy: "Gwoupe pa",
    day: "Jou",
    dateFrom: "Soti",
    dateTo: "Rive",
    apply: "Aplike",
    delete: "Efase",
    edit: "Modifye",
    confirm: "Konfime",
    payoutSuccess: "Peyman fèt",
    error: "Erè",
    success: "Siksè",
    lang: "Lang",
    quickSearch: "Chèche vit",
    poweredBy: "Operasyon Lotri",
    business: "Ajans",
    saveSettings: "Sove paramèt",
    chooseRole: "Chwazi wòl",
    welcomeBackTo: "Konekte nan kont ou",
    invalidCreds: "Idantifyan pa bon",
    quickSale: "Vant rapid",
    autoDetected: "Jwèt detekte",
    typeNumber: "Tape 2 a 5 chif",
    mariage: "Maryaj Boul",
    mariageHelp: "2 nimewo — genyen si toulède soti",
    pairsAuto: "Pè otomatik",
    pairsAutoHelp: "Plizyè nimewo, yon sèl pri",
    pairsAutoEnter: "Antre plizyè nimewo separe ak espas oswa vigil",
    commonAmount: "Pri komen",
    bulkAdd: "Ajoute tout",
    bolet: "Bòlèt",
    bolet2: "Bòlèt (2 chif)",
    pick3Label: "Pick 3",
    pick4Label: "Pick 4",
    pick5Label: "Pick 5",
    premye: "Premye (1ye)",
    dezyem: "Dezyèm (2yèm)",
    twazyem: "Twazyèm (3yèm)",
    mariageRate: "Maryaj",
    sessionMidday: "Midi",
    sessionEvening: "Aswè",
    eightDraws: "8 tiraj",
    pickThree: "Pick 3",
    pickFour: "Pick 4",
    pickFive: "Pick 5",
    saveAllResults: "Sove tout rezilta yo",
    boul1: "Boul 1",
    boul2: "Boul 2",
    boul3: "Boul 3",
    matched: "Sòti",
    notMatched: "Pa sòti",
    perItemEdit: "Modifye chak pri",
    convertedFrom: "Konvèti soti",
    address: "Adrès",
    ticketFooter: "Mesaj tikè",
    menu: "Meni",
    notifications: "Notifikasyon",
    noNotifications: "Pa gen notifikasyon",
    markAllRead: "Make tout li",
    online: "Konekte",
    offline: "Pa konekte",
    syncedTickets: "tikè senkwonize",
    failedSync: "senkwonizasyon echwe",
    nothingToSync: "Pa gen anyen pou senkwonize",
    pendingSync: "k ap tann",
    autoDoubles: "Doub otomatik (00→99)",
    bulkPaste: "Plizyè nimewo",
    printer: "Enprimant",
    printerConfig: "Konfigirasyon enprimant",
    printerType: "Tip enprimant",
    printerBluetooth: "Bluetooth",
    printerSerial: "USB (Web Serial)",
    printerNetwork: "Rezo (TCP)",
    printerBrowser: "Navigatè",
    printerWidth: "Lajè papye",
    printerIp: "Adrès IP",
    printerPort: "Pò",
    testPrint: "Teste enprime",
    printing: "Ap enprime...",
    deleteUser: "Efase itilizatè",
    deactivateUser: "Dezaktive",
    confirmDelete: "Konfime efase ?",
    editTicket: "Modifye tikè",
    cancelTicket: "Anile tikè",
    deleteTicket: "Efase tikè",
    cancelled: "Anile",
    superAdminActions: "Aksyon Sipèadmin",
    commission: "Komisyon %",
    commissionAmount: "Komisyon",
    nextDraw: "Pwochen tiraj",
    salesClosed: "Vant fèmen",
    salesOpenIn: "Ouvè nan",
    drawTime: "Lè tiraj",
    timezone: "Zòn lè",
    closeOffset: "Fèmen X min avan",
    importApi: "Enpòte rezilta API",
    importing: "Ap enpòte...",
    apiToken: "Token API",
    apiUrl: "URL API",
    downloadPdf: "Telechaje PDF",
    shareWhatsApp: "Pataje WhatsApp",
    lotteries: "Lotri yo",
  },
};

export const ROLES = [
  { value: "super_admin", labelFr: "Super Admin", labelHt: "Sipèadmin" },
  { value: "directeur", labelFr: "Directeur", labelHt: "Direktè" },
  { value: "superviseur", labelFr: "Superviseur", labelHt: "Sipèvizè" },
  { value: "admin", labelFr: "Admin", labelHt: "Admin" },
  { value: "sous_admin", labelFr: "Sous Admin", labelHt: "Asistan Admin" },
  { value: "machann", labelFr: "Machann", labelHt: "Machann" },
];

// Auto-detection: number of digits → game
export const detectGame = (digitsCount) => {
  switch (digitsCount) {
    case 2: return "bolet";
    case 3: return "pick3";
    case 4: return "pick4";
    case 5: return "pick5";
    default: return null;
  }
};

export const GAME_LABELS = {
  bolet: "BÒLÈT",
  mariage: "MARYAJ",
  mariage_gratis: "MARYAJ GRATIS",
  pick3: "PICK 3",
  pick4: "PICK 4",
  pick5: "PICK 5",
};
